import { render, staticRenderFns } from "./planFullTip.vue?vue&type=template&id=65e7b6da&scoped=true"
import script from "./planFullTip.vue?vue&type=script&lang=js"
export * from "./planFullTip.vue?vue&type=script&lang=js"
import style0 from "./planFullTip.vue?vue&type=style&index=0&id=65e7b6da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7b6da",
  null
  
)

export default component.exports